import React from "react";
import "../css/MainServices.css";
import assets from '../assets/images';
import { Link } from 'react-router-dom';


const services = [
  {
    title: "Wedding Photography",
    image: assets.d5,
    borderColor: "#00BFFF",
    button: "Read more",
  },
  {
    title: "Portrait Sessions",
    image: assets.d4,
    borderColor: "#FFD700",
    button: "Read more",
  },
  {
    title: "Event Coverage",
    image: assets.d2,
    borderColor: "#FFA500",
    button: "Read more",
  },
  {
    title: "Concerts",
    image: assets.d3,
    borderColor: "#FFD700",
    button: "Read more",
  },
];

const MainServices = () => {
  return (
    <section className="main-services-section">
      <h2 className="main-services-title">Main Services</h2>
      <div className="title-vis-line">
        <span className="vis-dot"></span>
        <span className="vis-line"></span>
        <span className="vis-dot"></span>
      </div>

      <div className="main-services-container">
        {services.map((service, index) => (
          <div
            key={index}
            className="service-card"
            style={{ borderColor: service.borderColor }}
          >
            <div className="image-wrapper">
              <img src={service.image} alt={service.title} className="service-image" />
            </div>
            <div className="service-overlay">
              <h3 className="service-title">{service.title}</h3>
              {service.button && (
                <Link to="/packages">
                  <button className="service-button">{service.button}</button>
                </Link>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MainServices;
